import translations from '@/components/translations/danishTranslations';

// Loaded with the lazy language provider, before its callbacks become usable.
// Translation callbacks also run in effects and event handlers, where throwing
// a loading promise cannot be handled by React Suspense.
export default function readDanishTranslations() {
  return translations;
}